export default {
	beforeMount: (el, binding, vNode) => {
		const ignoreMouse = binding.value.ignoreMouse ?? true;

		// Make sure expression provided is a function
		if (typeof binding.value.handler !== 'function') {
			const compName = vNode.context.name;
			let warn = `[longpress:] provided expression handler '${binding.expression}' is not a function, but has to be.`;
			if (compName) { warn += `Found in component '${compName}'` }
			console.warn(warn);
		}
		if (binding.value.hasOwnProperty('stopHandler') && typeof binding.value.stopHandler !== 'function') {
			const compName = vNode.context.name;
			let warn  = `[longpress:] provided expression stopHandler '${binding.expression}' is not a function, but has to be.`;
			if (compName) { warn += `Found in component '${compName}'` }
			console.warn(warn);
		}

		let pressTimer = null;
		const timeoutDuration = 500; // Configurable timeout duration
		let startPosition = { x: 0, y: 0 };
		const movementMargin = 10; // Margin for allowed movement

		const getTouchPosition = (e) => ({
			x: e.touches[0].clientX,
			y: e.touches[0].clientY
		});

		const isWithinMargin = (pos1, pos2) => {
			return Math.abs(pos1.x - pos2.x) <= movementMargin &&
				Math.abs(pos1.y - pos2.y) <= movementMargin;
		};

		const handlePressStart = (e) => {
			if ((e.type === 'mousedown' && ignoreMouse) && e.button !== 0) {
				return;
			}

			if (e.touches) {
				startPosition = getTouchPosition(e);
			}

			if (pressTimer === null) {
				pressTimer = setTimeout(() => {
					if ((e.touches && isWithinMargin(startPosition, getTouchPosition(e))) || (!e.touches && !ignoreMouse)) {
						handleLongPress(e);
					}
				}, timeoutDuration);
			}
		};

		const handlePressCancel = (e) => {
			if (pressTimer !== null) {
				clearTimeout(pressTimer);
				if(binding.value.hasOwnProperty('stopHandler')) {
					binding.value.stopHandler(e);
				}
				pressTimer = null;
			}
		};

		const handleMove = (e) => {
			if (e.touches && !isWithinMargin(startPosition, getTouchPosition(e))) {
				handlePressCancel();
			}
		};

		const handleLongPress = (e) => {
			if (typeof binding.value.handler === 'function') {
				binding.value.handler(e);
			}
		};

		el.addEventListener("mousedown", handlePressStart);
		el.addEventListener("mouseup", handlePressCancel);
		el.addEventListener("mouseleave", handlePressCancel);
		el.addEventListener("mousemove", handleMove);
		el.addEventListener("touchstart", handlePressStart);
		el.addEventListener("touchend", handlePressCancel);
		el.addEventListener("touchcancel", handlePressCancel);
		el.addEventListener("touchmove", handleMove);
	}
}